import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PPAuthService } from '../../../core/services/auth.service';
import { SocialAuthService } from "@abacritt/angularx-social-login";
import { FacebookLoginProvider, GoogleLoginProvider } from "@abacritt/angularx-social-login";
import { SocialUser } from "@abacritt/angularx-social-login";
import { Observable } from 'rxjs';


@Component({
  selector: 'app-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.scss'],
})
export class SocialLoginComponent implements OnInit {

  returnUrl: string;

  loading$: Observable<boolean>;

  constructor(
    private socialAuthService: SocialAuthService,
    private authService: PPAuthService,
    private route: ActivatedRoute
  ) { 

    this.loading$ = authService.loginByFacebookLoading$; 

  }


  public socialSignIn( socialPlatform: string ) {
    
    let socialPlatformProvider;
    
    if( socialPlatform == "facebook" ){
      socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
    } /*else if(socialPlatform == "google"){
      socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
    }*/
    
    this.socialAuthService.signIn( socialPlatformProvider ).then(
      (userData: SocialUser) => {
        this.authService.loginByFacebook( userData.authToken, false, this.returnUrl );
      }
    );

  }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => this.returnUrl = params['return']);
  }

}
